module.exports = __webpack_public_path__ + "img/Montmartre Bingo.114d441c.jpeg";